import { AuthenticationService } from './authentication.service';

export function authAppInitializerFactory(authService: AuthenticationService) {
    return () => {
        return authService.runInitialLoginSequence();
      };
}